import { render, staticRenderFns } from "./activity-thanks-letter.vue?vue&type=template&id=71a5afa4&scoped=true&"
import script from "./activity-thanks-letter.vue?vue&type=script&lang=js&"
export * from "./activity-thanks-letter.vue?vue&type=script&lang=js&"
import style0 from "./activity-thanks-letter.vue?vue&type=style&index=0&id=71a5afa4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5afa4",
  null
  
)

export default component.exports